import {IField, ITextField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {computed, ExtractPropTypes, getCurrentInstance, PropType} from "vue";

export function useChatFormInputProps<Field extends IField, Value = any>() {
    return {
        field: {
            type: Object as PropType<Field>,
            required: true
        },
        required: {
            type: Boolean
        },
        modelValue: {
            type: [Array, String, Object, Number, Boolean] as PropType<Value>
        },
        error: {
            type: Boolean
        }
    };
}

export function useChatFormInput(props: Readonly<ExtractPropTypes<ReturnType<typeof useChatFormInputProps>>>) {
    let placeholder = computed(() => {
        let placeholder = (props.field as ITextField).placeholder;
        return placeholder && placeholder.length ? placeholder : props.field.descr;
    });

    let instance = getCurrentInstance().proxy;

    function focus(): void {
        let input = instance.$refs.input as HTMLInputElement;
        if (input && typeof input.focus == "function") {
            input.focus();
        }
    }

    let isContinueAvailable = computed(() => {
        return (!props.required || (props.modelValue != null && (typeof props.modelValue != "string" || props.modelValue.length > 0)));
    });

    return {
        placeholder,
        exposedObject: {
            focus
        } as ChatFormInputInterface,
        isContinueAvailable
    };
}

export interface ChatFormInputInterface {
    focus: () => void
}